import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import { Avatar } from 'design-system/avatar';
import { CardView, rem, Spacer } from 'design-system';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const TrustStoryItem = ({ info, source, fullWidth, firstName, lastName, largeVerticalPadding, darkBackground, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    return (<CardView style={[
            staticStyles.container,
            fullWidth && staticStyles.fullWidth,
            largeVerticalPadding && staticStyles.largeVerticalPadding,
            darkBackground && styles.darkBackground,
        ]} noMargin withPadding>
      <Avatar medium size={40} borderWidth={1} imageUrl={source} name={firstName || 'firstName'} lastName={lastName || 'lastName'} color={colors.background.brandLight} fontColor={colors.text.textOnBrand}/>
      <Spacer w={16}/>
      <View style={staticStyles.flex}>{info}</View>
    </CardView>);
};
export default TrustStoryItem;
export const WIDTH = rem(310);
export const HALF_WIDTH = WIDTH / 2;
const styleSet = createStyleSheets((colors) => ({
    darkBackground: {
        backgroundColor: colors.background.dark,
    },
}));
const staticStyles = StyleSheet.create({
    container: {
        width: rem(310),
        height: rem(95),
        alignItems: 'center',
        flexDirection: 'row',
        marginHorizontal: rem(8),
    },
    flex: {
        flex: 1,
    },
    fullWidth: {
        width: undefined,
        height: undefined,
        marginHorizontal: 0,
    },
    largeVerticalPadding: {
        paddingVertical: rem(20),
    },
});
